import type { ColumnDef } from '@tanstack/react-table'

import AutomationIcon from '@/assets/icons/icon-automations.svg'
import { DataTable } from '@/components/ui/table/data-table'
import { Tooltip } from '@/components/ui/tooltip'

import type { TeamRole } from '../../types'
import { TeamAvatars } from '../../ui/roles/list/team-avatars'
import { TeamRoleActions } from '../../ui/roles/list/team-role-actions'

const getRoleTableColumns = () => {
  const columns: ColumnDef<TeamRole>[] = [
    {
      accessorKey: 'name',
      header: 'Name',
      cell: ({ row }) => {
        return (
          <div className="flex items-center space-x-2">
            {row.original.isDefault && (
              <Tooltip
                asChild
                content="This role is a default role and cannot be modified."
              >
                <span>
                  <AutomationIcon className="h-4 w-4" />
                </span>
              </Tooltip>
            )}
            <span>{row.original.name}</span>
          </div>
        )
      },
    },
    {
      id: 'members',
      accessorKey: 'members',
      header: 'Members',
      cell: ({ row }) => {
        return (
          <div className="flex -space-x-2 overflow-hidden p-1">
            {row.original.members.length > 0 ? (
              <TeamAvatars
                members={row.original.members}
                limit={5}
              />
            ) : (
              <span className="text-xs">No Members</span>
            )}
          </div>
        )
      },
    },
    {
      id: 'actions',
      header: () => <span className="ml-auto text-right">Actions</span>,
      cell: ({ row }) => <TeamRoleActions row={row} />,
    },
  ]

  return columns
}

interface Props {
  roles: TeamRole[]
}

export const TeamRoles = ({ roles }: Props) => {
  const columns = getRoleTableColumns()

  return (
    <DataTable
      enableSorting
      columns={columns}
      data={roles}
    />
  )
}
